let timeout: number | undefined;
export const useDebounce = (func: () => void, wait: number) => (): void => {
  const later = () => {
    timeout = undefined;
    func();
  };
  clearTimeout(timeout);
  timeout = Number(setTimeout(later, wait));
};
